import { NewExclusionListGzDataProvider } from '../dataProvider/NewExclusionListGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';

export class NewExclusionListDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, NewExclusionListGzDataProvider);
  }
}
